module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page bg-primary"
  }, [_c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("LOGIN")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "name": "username",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-alert-danger uk-margin"
  }, [_vm._v(_vm._s(_vm.errorMessages[_vm.error.code] || _vm.error.code || _vm.error))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("AANMELDEN")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('a', {
    staticClass: "uk-button uk-button-primary .uk-width-1-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loginFb()
      }
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: facebook"
    }
  }), _vm._v("Aanmelden met Facebook")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "wachtwoord-vergeten"
    }
  }, [_vm._v("Wachtwoord Vergeten?")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558446fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/Login.vue
// module id = 515
// module chunks = 1